import { render, staticRenderFns } from "./ModalOferta.vue?vue&type=template&id=5d91c672&scoped=true"
import script from "./ModalOferta.vue?vue&type=script&lang=js"
export * from "./ModalOferta.vue?vue&type=script&lang=js"
import style0 from "./ModalOferta.vue?vue&type=style&index=0&id=5d91c672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d91c672",
  null
  
)

export default component.exports